import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { HashLink as Link } from "react-router-hash-link";
import { ReactComponent as Icon } from "../Icons/downarrow.svg";
import navitems from "../json/Header.json";

const Header = ({ setprops }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [menuOpen, setIsMenuOpen] = useState(false);
  const [toggle, setToggle] = useState(-1);
  const [toggle1, setToggle1] = useState(-1);

  const [mobiletoggle, setMobileToggle] = useState(-1);
  const [mobile1toggle, setMobile1Toggle] = useState(-1);

  const ref = useRef();
  const mobref = useRef();
  const navbarRef = useRef();

  const toggleMenu = (id) => {
    if (toggle === id) {
      setToggle(-1);
    } else {
      setToggle(id);
    }
  };

  const mobtoggle = (id) => {
    if (mobiletoggle === id) {
      setMobileToggle(-1);
      setMobile1Toggle(-1);
    } else {
      setMobileToggle(id);
    }
  };
  const mob1toggle = (id) => {
    if (mobile1toggle === id) {
      setMobile1Toggle(-1);
    } else {
      setMobile1Toggle(id);
    }
  };

  const { pathname } = useLocation();

  let url = pathname.split("/");

  const handleclick = () => {
    setIsMenuOpen(!menuOpen);
  };

  useEffect(() => {
    if (isOpen === true || toggle !== -1) {
      setprops(true);
    } else {
      setprops(false);
    }
  }, [isOpen, toggle, setprops]);

  useEffect(() => {
    const closeMenus = (e) => {
      // Check if the click is outside the ref element and the toggle button
      if (
        ref.current &&
        !ref.current.contains(e.target) &&
        !e.target.closest(".menubtn") &&
        !e.target.closest(".mobile-toggle-button")
      ) {
        setIsOpen(false);
        setToggle(-1);
        setMobileToggle(-1);
      }
    };
    document.body.addEventListener("click", closeMenus);
    return () => document.body.removeEventListener("click", closeMenus);
  });

  useEffect(() => {
    const closeMenus = (e) => {
      // Check if the click is outside the ref element and the toggle button
      if (
        mobref.current &&
        !mobref.current.contains(e.target) &&
        !e.target.closest(".menubarbtn")
      ) {
        setIsMenuOpen((prev) => !prev);
      }
    };
    document.body.addEventListener("click", closeMenus);
    return () => document.body.removeEventListener("click", closeMenus);
  }, [mobref, menuOpen]);

  const preloadAllNavbarImages = () => {
    const container = navbarRef.current;
    console.log("container", container);

    if (!container) return;

    const imgTags = Array.from(container.querySelectorAll("img"));

    const imgPromises = imgTags.map((img) => {
      return new Promise((resolve) => {
        const src = img.currentSrc || img.src;
        if (!src) return resolve();
        const temp = new Image();
        temp.src = src;
        temp.onload = resolve;
        temp.onerror = () => {
          console.error("Failed to load:", src);
          resolve();
        };
      });
    });

    return Promise.all([...imgPromises]);
  };

  useEffect(() => {
    preloadAllNavbarImages();
  }, []);

  return (
    <div
      ref={navbarRef}
      className="w-full border-b-[1px] border-linebg bg-white whiteblock relative"
    >
      <div
        role="navigation"
        className="2xl:container flex  items-center header_outer relative z-50 mx-auto py-[18px] px-6 justify-between md:px-10 lg:px-20  lg:px-20 "
      >
        {/* <div className="flex relative w-full"> */}

        <div className="">
          <div className="max-[450px]:w-[120px] w-[150px] sm:w-[200px]  min-[1100px]:w-[17.153vw]  justify-left flex items-center">
            <Link to={"/"}>
              <img
                src={process.env.PUBLIC_URL + "/images/transformalogo.svg"}
                alt="Transforma_logo"
              />
            </Link>
          </div>
        </div>
        {/*MARK: For Desktop  */}
        <div className={` hidden min-[1100px]:flex items-center h-full`}>
          <div className="flex items-center space-x-7">
            {navitems.map((item, id) => (
              <div key={id} className="">
                {!item.submenu ? (
                  <Link
                    key={item.name}
                    to={item.href}
                    onClick={() => setToggle(-1)}
                    className={
                      item.id === toggle ||
                      (url[1] == "" && item.name == "Home") ||
                      url[1] === item.name.toLowerCase()
                        ? toggle == -1
                          ? "text-ctaorange text-base "
                          : "text-primarycolor hover:text-ctaorange text-base"
                        : "text-primarycolor hover:text-ctaorange text-base"
                    }
                    // aria-current={item.current ? "page" : undefined}
                  >
                    {item.name}
                  </Link>
                ) : (
                  <button
                    key={id}
                    onClick={() => toggleMenu(id)}
                    className={`flex items-center gap-2 menubtn 
                    ${
                      item.id === toggle
                        ? "text-ctaorange text-base navbtnafterclick "
                        : toggle == -1 && url[1] == item.name.toLowerCase()
                          ? "text-ctaorange "
                          : "text-primarycolor hover:text-ctaorange text-base navbtnafter"
                    }`}
                  >
                    {item.name}
                    <Icon
                      className={`w-[10px] h-[10px] menuarrow mt-[2px] ${
                        item.id === toggle
                          ? "text-ctaorange rotate-180"
                          : toggle == -1 && url[1] == item.name.toLowerCase()
                            ? "text-ctaorange "
                            : "text-primarycolor"
                      }`}
                    />
                  </button>
                )}
                {item.id === toggle ? (
                  <div className="absolute top-[87px] left-0 bg-white flex h-fit w-full">
                    {item.submenu ? (
                      <div
                        ref={ref}
                        className={`p-10 pl-20 flex flex-col   ${
                          id == 2 ? "w-full" : "w-4/5"
                        }`}
                      >
                        {item?.heading && (
                          <div className="mb-5">
                            <h4 className="text-primarycolor text-20 font-medium">
                              {item?.heading}
                            </h4>
                          </div>
                        )}
                        <div className="flex text-nowrap gap-y-4 gap-x-24 w-full flex-col">
                          {item.submenu.map((it, ind) => (
                            <div key={ind} className="flex gap-5 w-full">
                              <div
                                className={`${
                                  it.id === 1
                                    ? "grid grid-cols-2"
                                    : it.id !== 2
                                      ? "grid grid-cols-2  xl:grid-cols-3 justify-around"
                                      : "flex flex-wrap max-2xl:justify-between max-h-[55vh] "
                                } ${
                                  it.id === 5
                                    ? "flex flex-col grid-cols-3 gap-20"
                                    : "w-full"
                                }  gap-y-2 items-start overflow-auto gap-2`}
                              >
                                {/* <p className="text-18 font-semibold">
                                  {it.Title}
                                </p> */}
                                {it.menu.map((i, index) => (
                                  <div
                                    key={index}
                                    className={`flex gap-5 h-fit   ${
                                      it.id == 2 ? "w-fit" : "w-full"
                                    }`}
                                  >
                                    {/* <div
                                      key={index}
                                      // className={`flex gap-3 headermenu cursor-pointer  rounded-[16px] w-full  px-5  py-3 ${it.id !== 5 ? "hover:bg-gray " : "hover:text-ctaorange"} ${it.id == 2 ? "flex-col min-w-[250px] max-w-[250px] hover:bg-gray py-4" : "items-center min-w-[163px]  "} ${pathname==i.href?"bg-gray":""}`}
                                    > */}

                                    {it.id == 5 ? (
                                      <>
                                        <div className="flex flex-wrap flex-col ">
                                          <h4 className="text-18 text-primarycolor font-semibold pb-2 ">
                                            {i.name}
                                          </h4>

                                          {i.items.map((item, index) => (
                                            <Link
                                              onClick={() => setToggle(-1)}
                                              to={item.href}
                                              className={`text-16 hover:text-ctaorange py-[6px] rounded-lg w-full ${
                                                item.href === pathname
                                                  ? "text-ctaorange"
                                                  : "text-secondaryblack "
                                              }`}
                                            >
                                              <p className="font-medium">
                                                {item.name}
                                              </p>
                                              {/* <p className="text-wrap">{i.desc}</p> */}
                                            </Link>
                                          ))}
                                        </div>
                                      </>
                                    ) : (
                                      <Link
                                        onClick={() => setToggle(-1)}
                                        to={i.href}
                                        target={i.target ? "_blank" : "_self"}
                                        className={`flex gap-4 headermenu cursor-pointer rounded-[16px] w-full  ${
                                          it.id == 2
                                            ? "hover:bg-gray p-5"
                                            : "hover:text-ctaorange  pr-4  py-3"
                                        } ${
                                          it.id == 2
                                            ? "flex-col min-w-[250px] max-w-[315px] hover:bg-gray py-4"
                                            : "items-center min-w-[163px]"
                                        } ${
                                          i.href === pathname
                                            ? it.id == 2
                                              ? "bg-gray "
                                              : "text-ctaorange"
                                            : "text-primarycolor"
                                        }`}
                                      >
                                        {i.icon !== "" && (
                                          <img
                                            src={
                                              process.env.PUBLIC_URL + i.icon
                                            }
                                            alt="icon"
                                            className={`${it.id === 2 ? "w-fit h-fit" : "w-6 h-6"}`}
                                          />
                                        )}
                                        <p className="font-medium text-16 sm:text-18 text-wrap">
                                          {it.id == 2 ? i.desc : i.name}
                                        </p>
                                        {/* <p className="text-wrap">{i.desc}</p> */}
                                      </Link>
                                    )}

                                    {/* <img
                                        className="arrowheader"
                                        src={
                                          process.env.PUBLIC_URL +
                                          "/images/Header/rightarrow.svg"
                                        }
                                        alt="."
                                      /> */}
                                    {/* </div> */}
                                  </div>
                                ))}
                              </div>
                              {/* <div className="h-[190px] w-[190px] relative my-auto">
                                <img
                                  src={process.env.PUBLIC_URL + it.img}
                                  alt="demo_img"
                                  className="h-auto w-auto"
                                ></img>
                              </div> */}
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                    {item?.industry && (
                      <div
                        className={`relative  bg-[#EFF2FC] border-l-2 border-journycolor ${
                          item.industry?.length > 5 ? "w-2/6" : "w-1/5"
                        } `}
                      >
                        {item.industry ? (
                          <div className="flex flex-col h-full ml-5 lg:ml-5 mt-5">
                            <div className="text-20 font-semibold h-fit py-5">
                              <h4>INDUSTRY</h4>
                            </div>

                            <div
                              className={`flex flex-wrap gap-y-5 w-full h-fit pb-5 justify-between flex flex-wrap ${
                                item.industry?.length > 5
                                  ? "grid grid-cols-2"
                                  : " min-w-[163px] "
                              } `}
                            >
                              {item.industry.map((ind, k) => (
                                <div
                                  key={k}
                                  className={`flex text-18 text-primarycolor  font-normal   headermenu w-max justify-start flex-wrap ${
                                    item.industry?.length > 5
                                      ? "w-full"
                                      : " min-w-[163px] "
                                  }`}
                                >
                                  <p className="capitalize">{ind.name}</p>
                                </div>
                              ))}
                            </div>
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    )}
                  </div>
                ) : (
                  <></>
                )}
              </div>
            ))}
          </div>
        </div>
        <div className=" hidden min-[1100px]:flex flex justify-end ">
          <Link
            to={"/company/contactus"}
            className="lg:text-14 text-white font-semibold "
          >
            <button className="px-[23px] py-[15px] bg-orangebg rounded-[16px] flex items-center hover:bg-btnhover hover: bg-box-shadow:inset 5px -5px 4px #D73B00">
              Get a Quote
            </button>
          </Link>
        </div>

        {/* </div> */}
        {/*MARK: For Mobile */}

        <div className="flex min-[1100px]:hidden absolute md:right-[28px] lg:right-[70px] right-[10px] sm:right-[20px] z-300 menubarbtn">
          <button
            className="relative flex flex-col items-center justify-center w-12 h-12 rounded focus:outline-none"
            onClick={handleclick}
            aria-label="Show hide menu bar"
          >
            <span
              className={`block w-6 h-0.3 border-black border-[1px] opacity-75 border-black transform transition duration-300 ease-in-out ${
                menuOpen ? "rotate-45 translate-y-1" : "-translate-y-1.5"
              }`}
            ></span>
            <span
              className={`block w-6 h-0.3 border-black border-[1px] transform transition duration-300 ease-in-out ${
                menuOpen ? "opacity-0" : "opacity-75"
              }`}
            ></span>
            <span
              className={`block w-6 h-0.3 border-black border-[1px] opacity-75 transform transition duration-300 ease-in-out ${
                menuOpen ? "-rotate-45 -translate-y-1.2" : "translate-y-1.5"
              }`}
            ></span>
          </button>
        </div>
        {menuOpen ? (
          <div
            ref={mobref}
            className="absolute shadow-nav min-[1100px]:hidden bg-white top-[55px] sm:top-[68px] left-0 border-t-[1px] bprder-[#f5f5f5] w-full pt-3 md:px-10 lg:px-20  z-500 h-fit max-h-[70vh] overflow-auto"
          >
            <div className="flex flex-col w-full   ">
              {navitems.map((item, id) => (
                <div
                  className={`py-4 max-md:px-6   ${item.id === 5 ? "" : "border-b border-journyborder"} ${
                    !item.submenu ? "flex" : ""
                  }`}
                  key={id}
                >
                  {!item.submenu ? (
                    <Link
                      key={item.name}
                      to={item.href}
                      target={item.target ? "_blank" : "_self"}
                      onClick={() => setIsMenuOpen(!menuOpen)}
                      className={`text-16 md:text-18 font-semibold ${
                        item.href === url[1]
                          ? "text-ctaorange"
                          : "text-primarycolor hover:text-ctaorange "
                      } ${!item.submenu ? "w-full" : ""}`}
                    >
                      {item.name}
                    </Link>
                  ) : (
                    <button
                      key={id}
                      onClick={() => mobtoggle(id)}
                      className={
                        item.id === mobiletoggle
                          ? "text-ctaorange md:text-18 text-16 font-semibold navbtnafterclick mobile-toggle-button flex items-center gap-4 pr-2 w-full justify-between hover:text-ctaorange"
                          : "text-primarycolor md:text-18 text-16 w-full font-semibold justify-between  text-base navbtnafter pr-2 flex items-center gap-4"
                      }
                    >
                      {item.name}
                      <Icon
                        className={`menuarrow mt-1 ${
                          item.id === mobiletoggle
                            ? "text-ctaorange rotate-180"
                            : "text-black"
                        }`}
                      />
                    </button>
                  )}
                  {item.id === mobiletoggle ? (
                    <div className="relative overflow-auto">
                      {item.submenu ? (
                        <div className=" flex flex-col">
                          <ul className="flex flex-col gap-6">
                            {item.submenu.map((it, ind) => (
                              <div
                                key={ind}
                                className="flex flex-col gap-y-4 pt-3"
                              >
                                {item.heading && (
                                  <p className="text-16  font-normal text-primarycolor">
                                    {item.heading}
                                  </p>
                                )}
                                {it.menu.map((i, index) => (
                                  <>
                                    <div
                                      key={index}
                                      className="flex gap-4 w-full"
                                    >
                                      <li
                                        key={index}
                                        className={`flex   items-center w-full headermenu min-w-[166px] ${
                                          item.id == 5
                                            ? "flex-col  gap-3"
                                            : "hover:text-ctaorange gap-4"
                                        } `}
                                      >
                                        {i.icon !== "" &&
                                        item?.name !== "Products" ? (
                                          <img
                                            className="h-5 text-secondaryblack"
                                            src={
                                              it.id !== 2
                                                ? process.env.PUBLIC_URL +
                                                  i.icon
                                                : process.env.PUBLIC_URL +
                                                  i.icon1
                                            }
                                            alt="icon"
                                          ></img>
                                        ) : (
                                          <></>
                                        )}
                                        {item.id !== 5 ? (
                                          <Link
                                            onClick={() => setIsMenuOpen(false)}
                                            to={i.href}
                                            target={
                                              i.target ? "_blank" : "_self"
                                            }
                                            className={`text-14 sm:text-16   w-full `}
                                          >
                                            {i.name}
                                          </Link>
                                        ) : (
                                          i.items.map((its, ind) => (
                                            <Link
                                              key={ind}
                                              to={its.href}
                                              onClick={() =>
                                                setIsMenuOpen(false)
                                              }
                                              target={
                                                its.target ? "_blank" : "_self"
                                              }
                                              className={`text-14 sm:text-16 hover:text-ctaorange w-full 
                                               
                                              `}
                                            >
                                              {its.name}
                                            </Link>
                                          ))
                                        )}
                                      </li>
                                    </div>
                                  </>
                                ))}
                              </div>
                            ))}
                          </ul>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              ))}
            </div>
            {/* <Link
              onClick={() => setIsMenuOpen(!menuOpen)}
              to={"/company/contactus"}
              className="relative flex lg:hidden w-fit text-14 lg:text-[1.111vw] text-white font-medium bg-btnbg left-[0] px-[16px] py-[12px] ml-2 rounded-[12px] mt-[12px]"
            >
              CONTACT US
            </Link> */}
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default Header;
